
const state = () => ({})

const getters = {
  business: state => prop => null, // allows modifying business properties based on fiscality
  ticketInfo: state => null, // array of additional ticket header lines (defaults to waiter name)
  invoiceInfo: state => null, // additional invoice title, printed just before the invoice number
  fiscalInfo: state => null, // array of data used in the fiscal information dialog
  fiscalData: state => null, // invoice column
  orderMaxAmount: state => null, // REV-18237
  contentPrice: state => payload => null, // allows modifying each content price
  shouldAddReason: state => null, // waiter should add a reason when printing an already printed check
  shouldSignInvoice: state => null,
}

const mutations = {}

const actions = {
  printPreHeader ({}, { order, invoice }) {},
  printAdditionalHeader ({}, business) {},
  printAdditionalFooter ({}, business) {},
  printCheckSummary ({ dispatch }, order) {
    return dispatch('fiscalCountry/spain/printCheckSummary', order, { root: true })
  },
  printInvoiceSummary ({ dispatch }, { order, invoice }) {
    return dispatch('fiscalCountry/spain/printInvoiceSummary', { order, invoice }, { root: true })
  },
  signPrintCheck ({}, { order, reason }) {},
  signInvoice ({}, invoice) {},
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
